import script from "./MakersMove.vue?vue&type=script&lang=js"
export * from "./MakersMove.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__